import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enResources from "./Resources/en.json";
import arResources from "./Resources/ar.json";

const fallbackLng = ["en"];
const availableLanguages = ["en", "ar"];

export const i18nInit = () => {
  i18n.use(initReactI18next).init({
    resources: {
      en: { translation: enResources },
      ar: { translation: arResources },
    },
    lng: localStorage.getItem("language") || "en",
    fallbackLng,
    whitelist: availableLanguages,
    interpolation: {
      escapeValue: false,
    },
  });
};

export function translate(key, options, defaultValue) {
  return i18n.t(key, defaultValue, options);
}
